import { Component } from 'preact';
import { NavigationArrow } from './navigationArrow';

class NavigationBase extends Component {
  render(props, state) {

    const linkAction = e => {
      props.removeMenuItem(props.item);
      e.stopPropagation();
    }

    return (
      <div className={"navigation-link-base-container"}>
        <div className={"navigation-link-base-icon-title"}>
          <i className={"fas " + props.item.Icon}></i>
          <span>{props.item.Name}</span>
        </div>
        <NavigationArrow show={props.dropdown} open={props.open}></NavigationArrow>
        {!props.dropdown && !!props.item.Removable && <div className={"navigation-link-base-close"}><i onClick={linkAction} className={"fas fa-times"}></i></div> }
      </div>
    );
  }
}

export {NavigationBase};



// WEBPACK FOOTER //
// ./components/sidebar/navigationBase.js